import {
  FormProvider,
  type SubmitHandler,
  useFieldArray,
  useForm,
} from "react-hook-form";
import OzoneList from "src/components/pages/Settings/YachtSetUp/OzoneList/OzoneList";
import YachtSetupSectionHeader from "src/components/pages/Settings/YachtSetUp/YachtSetupSectionHeader";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi, usePostApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { getYachtId, validateDate } from "src/utils";
import { Notification } from "src/utils/Notification";

import {
  type IOzoneForm,
  type IOzoneItem,
} from "./OzoneDepletingSubstances.types";

const ozoneItem = {
  name: "",
  loc: "",
  no: "",
  type: "",
  isc: "",
  lubg: "",
  lubc: "",
  man: "",
  ref: "",
  sub: "",
  mass: "",
  date: "",
  defaultDate: null,
};

const mapOzones = (data: any): IOzoneItem[] => {
  const list = data?.data?.content?.data?.ozone;
  if (!list) return [ozoneItem];
  if (list.length === 0) return [ozoneItem];
  return list.map((el: any) => ({ ...el, defaultDate: validateDate(el.date) }));
};

const OzoneDepletingSubstances = () => {
  const { data, isLoading: isGetLoading } = useGetApi({
    request: "get-settings",
    body: { params: { sect: "_ozone" } },
    mapper: mapOzones,
  });

  const { post, isLoading: isPostLoading } = usePostApi();

  const methods = useForm<IOzoneForm>({
    values: { ozones: data ?? [] },
  });

  const { append, ...fieldArrayProps } = useFieldArray<IOzoneForm>({
    control: methods.control,
    name: "ozones",
  });

  const handleAppend = () => {
    append(ozoneItem);
  };

  const onSubmit: SubmitHandler<IOzoneForm> = async data => {
    const list = data.ozones.map(el => {
      const newEl = { ...el };
      delete newEl.defaultDate;
      return newEl;
    });
    const params = {
      data: list,
      section: "ozone",
      yachtid: getYachtId(),
    };

    await post({
      request: "save-yacht-info",
      body: { params },
      onSuccess: () => {
        methods.reset(data);
        Notification(
          "Success",
          "Ozone Depleting Substances have been successfully changed.",
          "green",
        );
      },
    });
  };
  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <YachtSetupSectionHeader
            onAdd={handleAppend}
            isSaving={isPostLoading}
            section="ozone"
          />
          {!data || isGetLoading ? (
            <Loader />
          ) : (
            <OzoneList {...fieldArrayProps} />
          )}
        </form>
      </FormProvider>
    </PageContainer>
  );
};

export default OzoneDepletingSubstances;
